import { atom, selector } from 'recoil'
import {
  NEW_EDIT_SOURCE_MAX_UPLOAD_SIZE,
  SOURCE_ID_TYPE_FILE,
  SOURCE_ID_TYPE_URL
} from 'Constants/index'
import {
  UPLOADER_VARIANT_DEFAULT,
  UPLOADER_VARIANT_UPLOADING,
  UPLOADER_VARIANT_UPLOADED,
  UPLOADER_VARIANT_DANGER
} from 'mailup-web-components'
import { regexUrl } from 'Helpers/regexHelpers'

export const MAX_CALLS = 3

export const ERROR_CODE_INVALID_EXT = 200
export const ERROR_CODE_INVALID_ZIP = 201
export const ERROR_CODE_PARSING = 202
export const ERROR_CODE_MAPPING = 204
export const ERROR_CODE_VALIDATING_HEADER = 203
export const ERROR_CODE_EMPTY_FILE = 205
export const ERROR_CODE_TOO_MANY_CONTENT = 206

export const sourceState = atom({
  key: 'SourceEdit__sourceState',
  default: {
    isDirty: false,
    idSource: 0,
    idType: SOURCE_ID_TYPE_URL,
    name: '',
    urlDisabled: false,
    isShared: false,
    sharedLists: [],
    selectAll: false,
    blockedLists: [],
    lastActivity: [],
    updateType: 0,
    contentfile: {
      isDirty: false,
      file: undefined,
      variant: UPLOADER_VARIANT_DEFAULT,
      warning: false
    },
    updateFrequency: {
      frequencyString: '',
      frequencyType: 0, // 1 m = 10, 2 11 < m < 29, 3 H
      hoursUpdateFreq: 6,
      minutesUpdateFreq: 15,
      stopUpdate: false
    }
  }
})

export const fileValidState = selector({
  key: 'SourceEdit__FileValidState',
  get: ({ get }) => {
    const {
      contentfile: { file }
    } = get(sourceState)
    return file && file.size < NEW_EDIT_SOURCE_MAX_UPLOAD_SIZE
  }
})

export const contentsState = atom({
  key: 'SourceEdit__contentsState',
  default: {
    loading: false,
    loaded: false,
    error: false,
    activity: undefined,
    contents: [],
    totalItems: 0,
    showBadge: false,
    callNum: -1
  }
})

export const lastUpdatedState = atom({
  key: 'SourceEdit__lastUpdatedState',
  default: {
    loading: false,
    loaded: false,
    error: false,
    updateDate: '',
    updateTime: '',
    isEnabled: false
  }
})

export const listState = atom({
  key: 'SourceEdit__listState',
  default: { lists: [] }
})

export const isDirtyState = atom({
  key: 'SourceEdit__isDirtyState',
  default: {
    isNameDirty: false,
    isUrlDirty: false
  }
})

export const isSaveBtnDisabled = selector({
  key: 'SourceEdit__isSaveBtnDisabled',
  get: ({ get }) => {
    const {
      name,
      url,
      idType,
      updateFrequency: { frequencyType, hoursUpdateFreq, minutesUpdateFreq },
      contentfile: { file, variant },
      updateType,
      idSource
    } = get(sourceState)
    const err = []

    let regexTest = true

    if (name.trim().length === 0) {
      err.push('error in name')
    }

    if (idType === SOURCE_ID_TYPE_FILE) {
      if (
        variant === UPLOADER_VARIANT_UPLOADING ||
        variant === UPLOADER_VARIANT_DANGER
      ) {
        err.push('error in uploader - must upload')
      } else if (variant === UPLOADER_VARIANT_DEFAULT) {
        if (
          (idSource !== 0 && file && updateType === 0) ||
          (!file && updateType !== 0)
        ) {
          err.push('error in uploader - updateType o file missing')
        } else if (idSource === 0 && !file) {
          err.push('error in uploader -- file missing')
        }
      } else if (variant === UPLOADER_VARIANT_UPLOADED) {
        if (idSource !== 0 && !file && updateType !== 0) {
          err.push('err in uploader -- file missing')
        }
        const { totalItems } = get(contentsState)
        if (totalItems > 0 && idSource !== 0 && file && updateType === 0) {
          err.push('error in uploader -- updateType missing')
        }
      }
    }

    if (idType === SOURCE_ID_TYPE_URL) {
      regexTest = regexUrl.test(url)

      if (!regexTest) {
        err.push('error in url regex')
      }

      if (
        frequencyType === 2 &&
        (minutesUpdateFreq < 11 || minutesUpdateFreq > 59)
      ) {
        err.push('error in content update - minutes number')
      }

      if (
        frequencyType === 3 &&
        (hoursUpdateFreq < 1 || hoursUpdateFreq > 24)
      ) {
        err.push('error in content update - hours number')
      }
    }

    return err.length
  }
})

export const updateFrequencyStringSelector = selector({
  key: 'SourceEdit__updateFrequencyStringSelector',
  get: ({ get }) => {
    const {
      updateFrequency: { frequencyType, hoursUpdateFreq, minutesUpdateFreq }
    } = get(sourceState)

    let frequencyString = ''
    switch (frequencyType) {
      case 1:
        frequencyString = '*/10 * * * *'
        break
      case 2:
        frequencyString = `*/${minutesUpdateFreq} * * * *`
        break
      case 3:
        frequencyString = `0 */${hoursUpdateFreq} * * *`
        break
    }
    return frequencyString
  }
})
